/**
 * 전역 비동기/런타임 오류 리스너.
 * 오류를 콘솔에 기록만 하고 삼키지 않는다(defaultPrevented 미사용).
 * SSR 환경에서는 window 가 없으므로 typeof window 가드로 보호.
 */

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    console.error("[GlobalError] Unhandled promise rejection:", event.reason);
  });

  window.addEventListener("error", (event: ErrorEvent) => {
    console.error(
      "[GlobalError] Uncaught error:",
      event.message,
      event.filename ? `(${event.filename}:${event.lineno})` : "",
      event.error,
    );
  });
}
